__turbopack_context__.v({
  "actionContainer": "ProductCard-module__m35kXa__actionContainer",
  "active": "ProductCard-module__m35kXa__active",
  "badge": "ProductCard-module__m35kXa__badge",
  "capsuleIcon": "ProductCard-module__m35kXa__capsuleIcon",
  "card": "ProductCard-module__m35kXa__card",
  "category": "ProductCard-module__m35kXa__category",
  "content": "ProductCard-module__m35kXa__content",
  "description": "ProductCard-module__m35kXa__description",
  "footer": "ProductCard-module__m35kXa__footer",
  "footerAdd": "ProductCard-module__m35kXa__footerAdd",
  "footerAddLabel": "ProductCard-module__m35kXa__footerAddLabel",
  "imageContainer": "ProductCard-module__m35kXa__imageContainer",
  "imageOverlay": "ProductCard-module__m35kXa__imageOverlay",
  "imagePlaceholder": "ProductCard-module__m35kXa__imagePlaceholder",
  "imageStage": "ProductCard-module__m35kXa__imageStage",
  "intensityBar": "ProductCard-module__m35kXa__intensityBar",
  "intensityContainer": "ProductCard-module__m35kXa__intensityContainer",
  "intensityLabel": "ProductCard-module__m35kXa__intensityLabel",
  "intensityMeter": "ProductCard-module__m35kXa__intensityMeter",
  "intensityValue": "ProductCard-module__m35kXa__intensityValue",
  "link": "ProductCard-module__m35kXa__link",
  "metaRow": "ProductCard-module__m35kXa__metaRow",
  "name": "ProductCard-module__m35kXa__name",
  "origin": "ProductCard-module__m35kXa__origin",
  "price": "ProductCard-module__m35kXa__price",
  "quickAdd": "ProductCard-module__m35kXa__quickAdd",
});
